import { ArgumentType } from "./argumentObject";

export const argumentTypeLabels: Record<ArgumentType, string> = {
  [ArgumentType.BINARY_TREE]: "Binary Tree",
  [ArgumentType.GRAPH]: "Graph",
  [ArgumentType.LINKED_LIST]: "Linked List",
  [ArgumentType.ARRAY]: "Array",
  [ArgumentType.MATRIX]: "Matrix",
  [ArgumentType.STRING]: "String",
  [ArgumentType.SET]: "Set",
  [ArgumentType.MAP]: "Map",
  [ArgumentType.OBJECT]: "Object",
  [ArgumentType.NUMBER]: "Number",
  [ArgumentType.BOOLEAN]: "Boolean",
};
